import type { ReactNode } from 'react';

import { ListRow, Text } from '@betterment/samba-react';

interface DrawerListRowProps {
  label: string;
  value: string | ReactNode;
  shouldLineThrough?: boolean;
  secondaryValue?: string;
  valueSubText?: string;
}

export const DrawerListRow: React.FC<DrawerListRowProps> = ({
  label,
  value,
  shouldLineThrough,
  secondaryValue,
  valueSubText,
}) => {
  return (
    <ListRow css={{ px: '0', pb: 'space.200', pt: 'space.200' }}>
      <ListRow.LeadingContent>
        <Text variant="text100">{label}</Text>
      </ListRow.LeadingContent>
      <ListRow.TrailingContent>
        {shouldLineThrough ? (
          <>
            <Text variant="text100" css={{ textDecoration: 'line-through' }}>
              {value}
            </Text>
            {valueSubText && (
              <Text variant="text50" color="text.weak" css={{ textDecoration: 'line-through' }}>
                {valueSubText}
              </Text>
            )}
          </>
        ) : (
          <>
            <Text variant="text100">{value}</Text>
            {valueSubText && (
              <Text variant="text50" color="text.weak">
                {valueSubText}
              </Text>
            )}
          </>
        )}
      </ListRow.TrailingContent>
      {secondaryValue && (
        <ListRow.BottomContent>
          <Text variant="text50">{secondaryValue}</Text>
        </ListRow.BottomContent>
      )}
    </ListRow>
  );
};
